// W-25: options for the Job and Assign To selects on the Add / Edit Task forms.
// CSelect uses item.value for each option, but /job and /user rows have no `value` (and users have no
// `name`), so the raw lists gave every option an undefined value. Options are built as { value, label }
// with integer ids.

// A positive integer id, or null.
export const toId = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isInteger(n) && n > 0 ? n : null;
};

const userLabel = (u) =>
  [u.firstName, u.lastName].filter(Boolean).join(" ") || u.name || u.email || `User ${u.id}`;

export const jobOptionsOf = (jobs) =>
  (Array.isArray(jobs) ? jobs : [])
    .filter((j) => j && toId(j.id) !== null)
    .map((j) => ({ value: toId(j.id), label: j.name || `Job ${j.id}` }));

export const userOptionsOf = (users) =>
  (Array.isArray(users) ? users : [])
    .filter((u) => u && toId(u.id) !== null)
    .map((u) => ({ value: toId(u.id), label: userLabel(u) }));
